import React, { createRef, PureComponent } from 'react';

import { BLOCK_TYPE, INLINE_STYLE } from '@whispir/draftail';
import { DraftailEditorWithVariables } from '../../DraftailComponents/DraftailEditorWithVariables';

import { Variable } from '../../Molecules/VariableSelectorPopover';
import {
  DraftailEditorWrapper,
  TextEditorContainer,
  HeadingContainer,
} from './RichTextFullWidthBannerBlock.style';
import { RichTextFullWidthBannerBlockProps } from './RichTextFullWidthBannerBlock.types';

type State = {
  selectedVariable: Variable | null;
};

const textAreaBlockTypes = [
  { type: BLOCK_TYPE.UNSTYLED },
  { type: BLOCK_TYPE.HEADER_ONE },
  { type: BLOCK_TYPE.HEADER_TWO },
  { type: BLOCK_TYPE.HEADER_THREE },
];

const textAreaInlineStyles = [
  { type: INLINE_STYLE.BOLD },
  { type: INLINE_STYLE.ITALIC },
];

export class RichTextFullWidthBannerBlock extends PureComponent<
  RichTextFullWidthBannerBlockProps,
  State
> {
  constructor(props: RichTextFullWidthBannerBlockProps) {
    super(props);
    this.state = {
      selectedVariable: null,
    };
  }

  componentDidUpdate(): void {
    const { focus, checkId } = this.props;
    // Overriding the beautiful-DND component library from stopping the focus shift out of the text editor components (Banner and Text components).
    // This is needed so that the Rich Text Editor component blurs when clicking a dnd component - hiding its toolbar
    const rteMenuSelector = document.querySelector<HTMLElement>(
      `.draft${checkId} .Draftail-Editor`
    );
    if (!focus) {
      if (rteMenuSelector) {
        rteMenuSelector.classList.remove('Draftail-Editor--focus');
      }
    }
  }

  onSaveHandler = (raw): void => {
    const { onChange, checkId } = this.props;
    onChange(JSON.stringify(raw), checkId);
  };

  render(): JSX.Element {
    const {
      raw,
      backgroundColor,
      textColor,
      src,
      height,
      width,
      textPosition,
      textPadding,
      marginTop,
      marginBottom,
      checkId,
      focus,
      variableMenuData,
      activeChannel,
    } = this.props;

    const imageSource = src.replace(/\\/g, '');

    const variableGroups =
      activeChannel !== 'form' ? variableMenuData : undefined;
    return (
      <TextEditorContainer
        focus={focus}
        key={checkId}
        backgroundColor={backgroundColor}
        imageSource={imageSource}
        height={height}
        width={width}
        marginTop={marginTop}
        marginBottom={marginBottom}
      >
        <HeadingContainer height={height} textPadding={textPadding}>
          <DraftailEditorWrapper
            className={`draft${checkId}`}
            height={height}
            width={width}
            textColor={textColor}
            textPosition={textPosition}
          >
            <DraftailEditorWithVariables
              placeholder=''
              blockTypes={textAreaBlockTypes}
              inlineStyles={textAreaInlineStyles}
              onSaveHandler={this.onSaveHandler}
              rawContentState={JSON.parse(raw)}
              spellCheck
              variableGroups={variableGroups}
              variableButtonClassName='variable-selector'
              hasFocus={focus}
            />
          </DraftailEditorWrapper>
        </HeadingContainer>
      </TextEditorContainer>
    );
  }
}
